module.exports = __webpack_public_path__ + "images/category_lp/common/pop-attention@2x_1d8b73d0e21fd79fff6bc800cb330287.png";